import { createRoot } from 'react-dom/client';
import { useEffect } from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';

import * as AxiosConfig from './config/init/axios';
import * as LanguageConfig from './config/init/language';
import { NavigationUtils } from 'utils';

import App from './App';

import '@mantine/carousel/styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const Initialization = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let apiRequestListener = AxiosConfig.setupAPIRequestListener();
    let apiResponseListener = AxiosConfig.setupAPIResponseListener();
    NavigationUtils.setNavigator(navigate);
    LanguageConfig.reloadResources();
    return () => {
      AxiosConfig.removeAPIRequestListener(apiRequestListener);
      AxiosConfig.removeAPIResponseListener(apiResponseListener);
    };
  }, []);

  return <></>;
}

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

createRoot(rootElement).render(
  <BrowserRouter>
    <Initialization />
    <App />
  </BrowserRouter>
);
